import React from 'react';

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = "w-12 h-12" }) => {
  return (
    <img 
      src="https://res.cloudinary.com/drkhlas0s/image/upload/v1779965461/jester_guogry.png" 
      alt="The Jesters Club South Africa" 
      className={`object-contain ${className}`}
    />
  );
};
